// api-dev now routes to the Lambda backend via CloudFront (cutover 2026-07-15)
export const API_BASE_URL = "https://api-dev.qapfinancials.com/api/v0";
// export const API_BASE_URL = "https://cyemaxq3edxgts4g2tbxupfhdm0xcyvr.lambda-url.us-east-2.on.aws/api/v0";
// export const API_BASE_URL = "http://localhost:8080/api/v0";
//sandbox link
// export const STRIPE_PAYMENT_LINK = "https://buy.stripe.com/test_14A00j6Hg6Y36WjbB39sk00"; 

//FREEURL
export const STRIPE_PAYMENT_LINK_FREE_TRIAL = "https://buy.stripe.com/8x2bJ08tP9aq8etbqn28805";

export const STRIPE_PAYMENT_LINK_NO_FREE_TRIAL = "https://buy.stripe.com/7sY28q5hD4UaamBeCz28806";



export const fetchAuthenticated = async (url, options = {}) => {
    // 1. Prepare base options with credentials enabled for cookies
    const fetchOptions = {
        ...options,
        credentials: "include", 
    };

    // 2. Initial attempt
    let response = await fetch(url, fetchOptions);
    // 3. Handle expired Access Token
    if (response.status === 401) {
        // Trigger the refresh endpoint
        // Browser sends the 'refreshToken' cookie automatically
        const refreshRes = await fetch(`${API_BASE_URL}/auth/refreshTokens`, {
            method: "POST",
            credentials: "include",
        });

        if (refreshRes.ok) {
            // Success! The backend just sent a new 'accessToken' cookie.
            // 4. Retry the original request (it will now use the new cookie)
            response = await fetch(url, fetchOptions);
        } else {
            // Refresh token is also expired or invalid
            console.warn("Refresh token expired. Redirecting to login.");
            window.location.href = "/";
            // Return a rejected promise to stop further .then() execution
            return Promise.reject("Session expired");
        }
    }

    // 5. Throw error for other status codes (500, 403, etc.)
    if (response.status === 404) {
        return null;
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const error = new Error(errorData.error || `Request failed with status ${response.status}`);
        // Expose the structured payload so callers can react to specific
        // backend errors (e.g. quickbooks_connection_expired)
        error.status = response.status;
        error.data = errorData;
        throw error;
    }

    return response;
};
